import { render, staticRenderFns } from "./TalentsTabs.vue?vue&type=template&id=7139ac9f"
import script from "./TalentsTabs.vue?vue&type=script&lang=js"
export * from "./TalentsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports